import { render, staticRenderFns } from "./SoftwareDistribute.vue?vue&type=template&id=5481f99f&scoped=true&"
import script from "./SoftwareDistribute.vue?vue&type=script&lang=js&"
export * from "./SoftwareDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5481f99f",
  null
  
)

export default component.exports